import { BrowserRouter, Route, Routes } from "react-router-dom";

import RouteAnalytics from "./analytics/RouteAnalytics";
import BasecampPage from "./pages/BasecampPage";
import KioskPage from "./pages/KioskPage";
import PrivacyPage from "./pages/PrivacyPage";
import SmsTermsPage from "./pages/SmsTermsPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";

const App = () => (
  <BrowserRouter>
    <RouteAnalytics />
    {/* Each Route's element gets a unique key so React remounts BasecampPage
        on every cross-route nav (e.g. /menu → /request). Without this, React
        reconciles the two BasecampPage instances together and the mount-only
        bootstrap effect doesn't re-run, leaving the wrong step on screen. */}
    <Routes>
      <Route path="/" element={<BasecampPage key="root" />} />
      <Route
        path="/request"
        element={<BasecampPage key="request" initialDestination="request" />}
      />
      <Route
        path="/checkout"
        element={<BasecampPage key="checkout" initialDestination="checkout" />}
      />
      <Route
        path="/menu"
        element={<BasecampPage key="menu" initialDestination="menu" />}
      />
      <Route path="/kiosk" element={<KioskPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/sms-terms" element={<SmsTermsPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
    </Routes>
  </BrowserRouter>
);

export default App;
